import { IProgressUpdateWithDeliveryDates, ProgressUpdateWithDeliveryDates } from "./ProgressUpdate";

export interface ICustomReportingEntityUpdate extends IProgressUpdateWithDeliveryDates {
    ReportingEntityID: number | null;
    CurrentPerformance: number | string;
}

export class CustomReportingEntityUpdate extends ProgressUpdateWithDeliveryDates implements ICustomReportingEntityUpdate {
    public ReportingEntityID: number  | null = null;
    public CurrentPerformance = '';

    constructor(reportingEntityId: number, period?: Date) {
        super(period);
        this.ReportingEntityID = reportingEntityId;
    }
}
